import React, { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";


const RegistrationNotice = () => {

    const { phase } = useContext(RegistrationContext);
    let message;
    switch (phase) {
        case 'first': message = "Early registration is open until June 15th 23:59 AoE"; break;
        case 'second': message = "Late registration is open until Jul 15th 23:59 AoE"; break;
        case 'third': message = "Onsite registration is open until Aug 30th 23:59 AoE"; break;
    }

    return (

        <div className="text-center py-4">
            <p className="text-gray-700 bg-amber-50 inline-block px-6 py-2 rounded-full border border-amber-100 shadow-sm">
                <span className="font-medium">Important:</span> {message}
            </p>
        </div>
    );
}

export default RegistrationNotice;
